import { StatusProp } from '../StatusTag/StatusTag';

export function advancementStatusToTagStatus(
  status: string = '',
): StatusProp | string {
  const normalized = status.toLowerCase();
  switch (normalized) {
    case 'started':
      return StatusProp.STARTED;
    case 'completed':
    case 'earned':
      return StatusProp.COMPLETED;
    case 'approved':
    case 'leader approved':
      return StatusProp.APPROVED;
    case 'awarded':
      return StatusProp.AWARDED;
    case 'declined':
      return StatusProp.DECLINED;
    case '':
      return StatusProp.NOT_STARTED;
    default:
      return normalized;
  }
}
